var amt_admin = require('amt_admin').default;
var app = require("angular").module("ww2_analytics.sessions", [amt_admin]);

var main_tpl = require("./main.html");

app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider.state("amt.ww2.sessions", {
      url: "/session",
      template: main_tpl,
      reloadOnSearch: false,
      data: {
        priority: 801,
        title: "Sessions",
        role: "sessions"
      },
      menu: {
        glyphicon: "lock"
      },
      controller: ["$scope", "$location", function($scope, $location) {}]
    });
  }
]);

export default app.name;
